/* --------------------------------------------------------
  Javascript for Sweat Szn

  version: 1.0
  last modified: 24.05.2021 by George Danchev
  author: George Danchev
  email: george.danchev@kubixmedia.co.uk
  website: https://kubixmedia.co.uk
---------------------------------------------------------- */

import ProductGallery from "./modules/product-gallery";

const productGallery = new ProductGallery();
